<template>
    <div id="authentication">
        <div class="container">

            <!-- 決済フォーム -->
            <p class="text-center d-block mt-5">Paypal決済</p>
            <div>
                <p>
                    Paypalによるお支払いで「DEVEREACH」をご利用いただくには、「アクセスキー」が必要です。<br>
                    「アクセスキー」はPayPalの定期購読（月額99,900円）を設定後、表示されます。（初月無料でいつでもキャンセル可能です）
                </p>
                <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                    <input type="hidden" name="cmd" value="_s-xclick">
                    <input type="hidden" name="hosted_button_id" value="JUK9T696G4WGU">
                    <input type="image" src="https://www.paypalobjects.com/ja_JP/JP/i/btn/btn_subscribeCC_LG.gif" border="0" name="submit" alt="PayPal - オンラインでより安全・簡単にお支払い">
                    <img alt="" border="0" src="https://www.paypalobjects.com/ja_JP/i/scr/pixel.gif" width="1" height="1">
                </form>
            </div>
            <!-- 決済フォーム -->

            <!-- キー入力 -->
            <p class="text-center d-block mt-5">「アクセスキー」取得後、下記ボックスにキーを入力してください。</p>
            <p class="text-danger">{{ messageByKey }}</p>
            <div class="input-group">
                <input id="auth-key" type="text" class="form-control" placeholder="キーを入力" v-model="authKey">
                <span class="input-group-btn">
                <button id="auth-button" type="button" class="page-link text-dark d-inline-block" @click="certifyWithKey">
                    <span :class="{'spinner-border': loading, 'spinner-border-sm': loading, 'mr-2': loading}"></span>送信
                </button>
                </span>
            </div>
            <!-- キー入力 -->
            
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getCokkieValueByKey } from '../../utils/cokkie'

export default {
    data() {
        return {
            authKey: '',
            loading: false
        }
    },
    computed: {
        ...mapState({
            apiStatus: state => (state.auth.apiStatus),
            isValid: state => (state.auth.isValid),
            messageByKey: state => (state.auth.messageByKey)
        })
    },
    mounted() {
        this.init()
    },
    methods: {
        // CookieにauthKeyがあればそれを参照する
        init() {
            let authKey = getCokkieValueByKey('authKey')

            if (authKey.trim() !== '') {
                this.authKey = authKey
            }
        },
        // キーの認証
        async certifyWithKey() { 

            if (!this.isValidate()) {
                return
            }

            try {
                this.loading = true
                await this.$store.dispatch('auth/certifyAuhtKey', this.authKey)
            } finally {
                this.loading = false
            }

            if (this.apiStatus && this.isValid) {
                this.$router.push({ name: 'top' })
            }
        },
        // キー入力バリデーション
        isValidate() {
            // TODO: componentからmutationを発火させるのはライフサイクル的によくない？（actionsから発火させるべき？）
            if (this.authKey.trim() === '') {
                this.$store.commit('auth/setMessageByKey', 'キーを入力してください')
                return false
            }

            return true
        }
    }
}
</script>

<style scoped>
#authentication {
  position: fixed;
  background: white;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  text-align: center;
  overflow-y: auto;
}
</style>